import { useShowConsumerCampaignById } from '@givebacks/api/store';
import { ProgressData } from 'core/Components';
import { Flex, Stack } from 'ui';

import { useCrowdfundingProvider } from '../../../Context';
import { CampaignCountdown } from '../InfoIcons/CampaignCountdown';
import { CampaignParticipants } from '../InfoIcons/CampaignParticipants';

export const CampaignProgress = ({
  campaignId,
  size,
  causeId,
}: {
  campaignId?: string;
  causeId?: string;
  size?: 'lg' | 'sm';
}) => {
  const { data: campaign } = useShowConsumerCampaignById({ campaignId, causeId });
  const isAthon = campaign?.__type == 'athon';
  const amountPledged = isAthon ? campaign.amount_pledged : undefined;

  return (
    <ProgressData
      size={size}
      goal={campaign?.show_goal ? campaign?.goal : undefined}
      amount_raised={campaign?.amount_raised ?? 0}
      amount_pledged={amountPledged}
      showAmountRaised={campaign?.show_amount_raised}
    />
  );
};

export const CampaignProgressWithStats = ({ size }: { size?: 'lg' | 'sm' }) => {
  const { campaignId, causeId } = useCrowdfundingProvider();
  const { data: campaign } = useShowConsumerCampaignById({ campaignId, causeId });

  return (
    <Stack miw={{ base: 'auto', md: '350px' }}>
      {(campaign?.show_amount_raised || campaign?.show_goal) && (
        <CampaignProgress campaignId={campaignId} size={size} causeId={causeId} />
      )}
      <Flex gap={'xl'}>
        {campaign?.show_amount_raised && (
          <CampaignParticipants number={campaign?.number_of_donations} />
        )}
        <CampaignCountdown end={campaign?.expires_at} />
      </Flex>
    </Stack>
  );
};
